// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/chart-preparation-marking.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/chart-preparation-marking/chart-preparation-marking.js';

mount([g0]);
